import React, { useEffect, useState, memo } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import Flex from '../../../../components/layouts/Flex'
import { Button } from '../../../../components/Button'

import axiosInstance from '../../../../services/config/AxiosIntance'

import {
  setDownload,
  setFilters,
  clearFilters,
  setLoading,
} from '../../../../store/actions/dashboardActions'

const SuccessRateFilter = () => {
  const dispatch = useDispatch()

  const filters = useSelector((state) => state.dashboard.filters)
  const loading = useSelector((state) => state.dashboard.loading)

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [minDate, setMinDate] = useState(new Date())
  const [maxDate, setMaxDate] = useState(new Date())
  const dates = filters.dates

  useEffect(() => {
    axiosInstance.get('/dashboard/dates').then((response) => {
      const dates = response.data.result[0]
      setMinDate(new Date(dates.oldest_date))
      setMaxDate(new Date())
    })

    // set start date to 1 month before the current date
    const startDate = new Date()
    startDate.setMonth(startDate.getMonth() - 1)

    dispatch(setFilters({ dates: [startDate, dates[1]] }))
  }, [])

  const handleStartDate = (date) => {
    dispatch(setFilters({ dates: [date, dates[1]] }))
  }

  const handleEndDate = (date) => {
    dispatch(setFilters({ dates: [dates[0], date] }))
  }

  const handleDownloadPDF = () => {
    dispatch(setLoading(true))
    dispatch(setDownload('success-rate-pdf'))
  }

  const handleResetFilters = () => {
    dispatch(clearFilters())
  }

  useEffect(() => {
    setStartDate(new Date(dates[0]))
    setEndDate(new Date(dates[1]))
  }, [dates])

  return (
    <>
      <Flex direction="column">
        <Flex gap="0.5rem">
          <label htmlFor="startDate">Start Date</label>
          <ReactDatePicker
            id="startDate"
            selected={filters.dates[0]}
            onChange={(e) => handleStartDate(e)}
            dateFormat="MMMM dd, yyyy"
            placeholderText="Enter Start Date"
            minDate={minDate}
            maxDate={endDate}
          />
          <label htmlFor="endDate">End Date</label>
          <ReactDatePicker
            id="endDate"
            selected={filters.dates[1]}
            onChange={(e) => handleEndDate(e)}
            dateFormat="MMMM dd, yyyy"
            placeholderText="Enter End Date"
            minDate={startDate}
            maxDate={maxDate}
          />
        </Flex>
        <br />
        <Flex width="100%">
          <Button
            height="auto"
            fontSize="1rem"
            handleClick={handleResetFilters}
          >
            Clear Filters
          </Button>
        </Flex>

        <Flex width="100%" margin="0.5rem 1.5rem 0.5rem 0" gap="0.5rem">
          <Button height="auto" fontSize="1rem" handleClick={handleDownloadPDF} disabled={loading}>
            {loading ? 'Exporting...' : 'Export All Charts'}
          </Button>
        </Flex>
      </Flex>
    </>
  )
}

export default memo(SuccessRateFilter)
